import api from '@/assets/plugins/axios'
import {backendUrl} from '@/assets/js/config'
let headers = {'Content-type': 'application/json'}
class RecordsService {
  getRecordsTypes (params, projectId){
    return api.get(`${backendUrl}/project/${projectId}/log/operate_types`).then(ret => {
      console.log(ret)
      return ret
    })
  }
  getRecordsList (params, projectId){
    return api.post(`${backendUrl}/project/${projectId}/log/list`, params, headers).then(ret => {
      console.log(ret)
      return ret
    })
  }
  sendRecordsLog (params){
    return api.post(`${backendUrl}/project/${projectId}/log`, params, headers).then(ret => {
      console.log(ret)
      return ret
    })
  }


  // 项目空间操作记录
  companyProjectList (params){
    return api.get(`${backendUrl}/project/list`, params).then(ret => {
      console.log(ret)
      return ret
    })
  }
  deletePrj (params) {
    return api.post(`${backendUrl}/file/delete`, params, headers).then(ret => {
      console.log(ret)
      return ret
    })
  }
  confirmRenamePrj (params) {
    return api.post(`${backendUrl}/file/rename`, params, headers).then(ret => {
      console.log(ret)
      return ret
    })
  }
  // 获取项目空间操作列表
  companyOprationList (params, path) {
    if (/\/database\/data\/record\//.test(window.location.href)) {
      return api.post(`${backendUrl}/projects/recorded/${path.projectId}/logs/search`, params).then(ret => {
        console.log(ret)
        return ret
      })
    }
    return api.post(`${backendUrl}/project/${path.projectId}/logs/search`, params).then(ret => {
      console.log(ret)
      return ret
    })
  }
  // 获取项目空间操作类型
  companyOprationTypes (params, path) {
    if (/\/database\/data\/record\//.test(window.location.href)) {
      return api.post(`${backendUrl}/projects/recorded/${path.projectId}/logs/operate_types`, params).then(ret => {
        console.log(ret)
        return ret
      })
    }
    return api.post(`${backendUrl}/project/${path.projectId}/logs/operate_types`, params).then(ret => {
      console.log(ret)
      return ret
    })
  }

  /** 1.1记录项目操作(创建、重命名、删除)
	 * @params Object params
	 */
  addCompanyProjectOpration (params, path) {
    if (params.records){
      params.records = JSON.stringify(params.records)
    }
    return api.postArr(`${backendUrl}/project/${path.projectId}/logs`, params).then(ret => {
      console.log(ret)
      return ret
    })
  }
  /** 1.2记录项目级操作、企业共享工程操作
	 * @params Object params
	 */
  addCompanyOpration (params, path) {
    if (params.records){
      params.records = JSON.stringify(params.records)
    }
    return api.postArr(`${backendUrl}/${path.workspaceId}/logs`, params).then(ret => {
      console.log(ret)
      return ret
    })
  }
  /** 1.3记录企业数据操作【删除、导出、修改、移动】
	 * @params Object params
	 */
  addCompanyDataOpration (params, path) {
    if (params.records){
      params.records = JSON.stringify(params.records)
    }
    return api.postArr(`${backendUrl}/${path.workspaceId}/logs/data`, params).then(ret => {
      console.log(ret)
      return ret
    })
  }
}
export default new RecordsService()
